export const FORM_STYLE = "container col-md-auto my-5 text-center border border-dark rounded-4 bg-white p-2"
export const FORM_GUIA_STYLE = "container d-flex flex-column col-md-auto bg-white border border-dark rounded-3 pt-3 mb-3"
export const TAX_FORM_STYLE = "container col-md-auto bg-white border border-dark rounded-5 mb-3 shadow"
export const LINK_STYLE = "rounded-5 btn btn-primary border border-primary"
export const BUTTON_STYLE = "rounded-5 border border-primary"